<template>
    <div
        class="flex flex-col items-start gap-2 flex-1 px-4 py-5 sm:p-4 overflow-hidden md:rounded-lg"
    >
        <dt class="flex py-1 items-center self-stretch">
            <div class="flex justify-between w-full">
                <div class="text-lg font-medium text-slate-800">
                    Total points
                </div>
                <div class="text-sm font-medium text-slate-800 flex items-center justify-center px-auto">
                    <a href="/mypoints/" class="rounded text-slate-800 hover:bg-slate-200 active:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-0 inline-block">
                        <icon icon="arrow" />
                    </a>
                </div>
            </div>
        </dt>

        <dd class="mt-1 text-3xl font-medium text-slate-800 mb-3">
            <template v-if="points === 0">
                <hr class="w-4 border-slate-800 border-b-2 rounded-md text-3xl font-semibold text-slate-900 mb-3 mt-6">
                <div class="text-xs font-medium text-slate-400 mt-6">Points</div>
            </template>
            <template v-else>
                <count-up :end-val="points" class="mb-1"></count-up>
                <div class="text-sm font-medium text-slate-500 mt-3">Points</div>
            </template>
        </dd>

        <div class="flex justify-between md:block 2xl:flex">
            <!--<dt class="truncate mt-3" v-if="points > 0">
                <div class="justify-between">
                    <div class="flex flex-col items-end">
                        <div
                            v-if="direction === 'up'"
                            class="
                                inline-flex
                                items-baseline
                                px-2.5
                                py-0.5
                                rounded-full
                                text-sm
                                font-medium
                                bg-green-100
                                text-green-800
                                md:mt-2
                                lg:mt-0
                            "
                        >
                            <svg
                                class="
                                    -ml-1
                                    mr-0.5
                                    h-5
                                    w-5
                                    flex-shrink-0
                                    self-center
                                    text-green-500
                                "
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                            <span class="sr-only"> Increased by </span>
                            {{ change }}
                        </div>

                        <div
                            v-if="direction === 'down'"
                            class="
                                inline-flex
                                items-baseline
                                px-2.5
                                py-0.5
                                rounded-full
                                text-sm
                                font-medium
                                bg-red-100
                                text-red-800
                                md:mt-2
                                lg:mt-0
                            "
                        >
                            <svg
                                class="
                                    -ml-1
                                    mr-0.5
                                    h-5
                                    w-5
                                    flex-shrink-0
                                    self-center
                                    text-red-500
                                "
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                            <span class="sr-only"> Decreased by </span>
                            {{ change }}
                        </div>

                        <div
                            v-if="direction === 'none'"
                            class="
                                inline-flex
                                items-baseline
                                px-2.5
                                py-0.5
                                rounded-full
                                text-sm
                                font-medium
                                bg-slate-100
                                text-slate-800
                                md:mt-2
                                lg:mt-0
                            "
                        >
                            &mdash;&nbsp;
                            <span class="sr-only"> No change </span>
                            {{ change }}
                        </div>

                        <span class="text-xs italic text-gray-400"
                            >Since Last Update</span
                        >
                    </div>
                </div>
            </dt>-->
        </div>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import { useDashboardStore } from '@/store/dashboard';
import CountUp from 'vue-countup-v3';
import Icon from '../../ui/icon/icon.vue';

export default {
    props: [],
    components: {
        Icon,
        CountUp,
    },
    computed: {
        ...mapState(useDashboardStore, [
            'loading',
            'points',
            'change',
            'direction',
        ]),
    },
    data: () => ({}),
    methods: {},
    created() {},
    mounted() {},
};
</script>
